import React, { useEffect } from "react";
import PaletteSubType from "./PaletteSubType";

export default function PaletteTools() {
  return (
    <>
      <PaletteSubType
        title="Header"
        path="palette.header"
        paletteValues={[
          ["Background Color", "backgroundcolor"],
          ["Text Color", "textcolor"],
          ["Button Background Color", "button.background"],
          ["Button Text Color", "button.color"],
          ["Button Border", "button.border"],
          ["Button Hover Background Color", "button.hoverbackground"],
          ["Button Hover Text Color", "button.hovercolor"],
        ]}
      />
      <PaletteSubType
        title="Navbar"
        path="palette.navbar"
        paletteValues={[
          ["Background Color", "backgroundcolor"],
          ["Text Color", "textcolor"],
        ]}
      />
      <PaletteSubType
        title="Message"
        path="palette.message"
        paletteValues={[
          ["Background Color", "backgroundcolor"],
          ["Text Color", "textcolor"],
        ]}
      />
      <PaletteSubType
        title="Error Message"
        path="palette.errormessage"
        paletteValues={[
          ["Background Color", "backgroundcolor"],
          ["Text Color", "textcolor"],
        ]}
      />
      <PaletteSubType
        title="Warning Message"
        path="palette.warningmessage"
        paletteValues={[
          ["Background Color", "backgroundcolor"],
          ["Text Color", "textcolor"],
        ]}
      />
      <PaletteSubType
        title="Link Text"
        path="palette.linktext"
        paletteValues={[
          ["Text Color", "color"],
          ["Hover Test Color", "hovercolor"],
        ]}
      />
      <PaletteSubType
        title="Body"
        path="palette.body"
        paletteValues={[
          ["Background Color", "backgroundcolor"],
          ["Text Color", "textcolor"],
        ]}
      />
      <PaletteSubType
        title="Card"
        path="palette.card"
        paletteValues={[
          ["Background Color", "backgroundcolor"],
          ["Text Color", "textcolor"],
        ]}
      />
      <PaletteSubType
        title="Primary Button"
        path="palette.button"
        paletteValues={[
          ["Primary Button Background Color", "primary.background"],
          ["Primary Button Text Color", "primary.color"],
          ["Primary Button_Border", "primary.border"],
          ["Primary Button_shadow", "primary.boxshadow"],
          ["Primary Button_Hover Background Color", "primary.hoverbackground"],
          ["Primary Button_Hover Text Color", "primary.hovercolor"],
          ["Primary Button_Hover_Border", "primary.hoverborder"],
          ["Primary Button_Hover_Shadow", "primary.boxhovershadow"],
        ]}
      />
      <PaletteSubType
        title="Secondary Button"
        path="palette.button"
        paletteValues={[
          ["Secondary Button Background Color", "secondary.background"],
          ["Secondary Button Text Color", "secondary.color"],
          [
            "Secondary Button Hover Background Color",
            "secondary.hoverbackground",
          ],
          ["Secondary Button Hover Text Color", "secondary.hovercolor"],
        ]}
      />
      <PaletteSubType
        title="Sub Footer"
        path="palette.subfooter"
        paletteValues={[
          ["Background Color", "backgroundcolor"],
          ["Text Color", "textcolor"],
        ]}
      />
      <PaletteSubType
        title="Footer"
        path="palette.footer"
        paletteValues={[
          ["Background Color", "backgroundcolor"],
          ["Primary Text_Color", "textcolor.primary.textcolor"],
          ["Secondary Text_Color", "textcolor.secondary.textcolor"],
        ]}
      />
    </>
  );
}
